import {useState, useEffect, ReactElement} from 'react'

type Props = {
}

export function OAuthResponse(_props: Props): ReactElement {
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.hash.slice(1))
    const [tokenType, accessToken, expiresIn] = [
      "token_type", "access_token", "expires_in"].map(
        param => searchParams.get(param));
    if ((tokenType === "bearer" && accessToken && expiresIn)) {
      const validTill = new Date(Date.now() + parseInt(expiresIn) * 1000)
      const loginInfo = {accessToken, validTill}
      document.location.hash = ""

      const myorigin = new URL(window.location.toString()).origin
      if (window.opener
            && new URL(window.opener.location.toString()).origin === myorigin) {
        window.opener.postMessage({loginInfo}, myorigin)
        document.location.hash = ""
        setSuccess(true)
      }
    }
  }, [])

  if (success) {
    return <div>Login successful, this window should be closed :)</div>
  }
  return <div>Something went wrong, please retry logging in</div>
}
